import { FC } from 'react';
import { Provider } from 'effector-react/scope';
import { FieldProps } from '../../interfaces';
import { createScope } from '../../models';
import { TypeSimpleTree } from './typeSimpleTree';

/* Осторожно! этот компонент переиспользован в экране диспетчера */
const TypeSimpleTreeField: FC<FieldProps> = (props) => {
  const onChange = (value: string[]) => props.form.setFieldValue(props.field.name, value);

  const scope = createScope(props.id);

  return (
    <Provider value={scope}>
      <TypeSimpleTree onChange={onChange} {...props} />
    </Provider>
  );
};

export { TypeSimpleTreeField };
export * from './typeSimpleTree';
